export default __webpack_public_path__ + "static/430-35d4f21332b3ee7fbcbe31d0a0efc072.jpg";